module.exports = onIntersect

function onIntersect(el, opts, onEnter, onExit) {
  if (typeof opts === 'function') {
    onExit = onEnter
    onEnter = opts
    opts = {}
  }

  onEnter = onEnter || noop
  onExit = onExit || noop

  var wasCalled = false
  var observer = new window.IntersectionObserver(handler, opts)
  observer.observe(el)

  return function () {
    observer.disconnect()
  }

  function handler(entries) {
    var entry = entries[0]

    // This covers subtle edge cases where the intersection value is 0.
    // See: https://github.com/yoshuawuyts/on-intersect/issues/2
    var isNotIntersecting =
      typeof entry.isIntersecting === 'boolean'
        ? !entry.isIntersecting
        : entry.intersectionRatio === 0

    if (isNotIntersecting) {
      // Make sure it's not called immediately when loaded.
      if (wasCalled) onExit(entry)
    } else {
      onEnter(entry)
    }

    wasCalled = true
  }
}

function noop() {}
